module.exports = __webpack_public_path__ + "static/img/10bg_10.c61b506.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_10.png
// module id = 617
// module chunks = 1